/**
 * RichTextTable
 */

import React, { useRef, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import clsx from 'clsx';
import { useSelector } from 'react-redux';
import { selectEpi } from 'store/modules/epi';
import { TableFragmentModel } from 'types';

function noLinebreaksInNumbers(rot = document) {
	// Matchar tal som "1 589 140", "626 284", "2 994 008"
	// \u0020 = vanligt mellanslag, \u00A0 = befintligt nbsp
	const talRegex = /\d{1,3}([\u0020\u00A0]\d{3})+/g;

	const walker = document.createTreeWalker(rot, NodeFilter.SHOW_TEXT);
	const noder = [];
	while (walker.nextNode()) noder.push(walker.currentNode);

	for (const nod of noder) {
		// @ts-ignore
		if (talRegex.test(nod.nodeValue)) {
			// @ts-ignore
			nod.nodeValue = nod.nodeValue.replace(talRegex, (m) =>
				m.replace(/[\u0020\u00A0]/g, '\u00A0')
			);
		}
	}
}

interface Props {
	tableData: TableFragmentModel;

	/** Optional className */
	className?: string;
}
/** RichTextTable component. */
const RichTextTable: React.FC<Props> = ({ tableData }) => {
	const nodeRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		if (nodeRef.current) {
			nodeRef.current
				.querySelectorAll('table')
				// @ts-ignore
				.forEach((t) => noLinebreaksInNumbers(t));
		}
		// eslint-disable-next-line
	}, []);

	return (
		<div className="mt-10 mb-10 richtext">
			<div
				ref={nodeRef}
				className={clsx(
					'table-scrollable',
					tableData.stickyColumn && 'table-sticky-col'
				)}
				dangerouslySetInnerHTML={{ __html: tableData.raw }}
			/>
		</div>
	);
};

export default RichTextTable;
